import type { IJobAssociatedAssetInfo } from '@/interfaces'
import type { IDecimalValueAndUnit } from '@/interfaces/IDecimalValueAndUnit'
import { containsAllValues } from '@/utils/helpers/app-helpers'
import DecimalValueAndUnit from '../DecimalValueAndUnit'

class JobAssociatedAssetInfo implements IJobAssociatedAssetInfo {
  machineHours: number

  odometerReading: IDecimalValueAndUnit | null

  constructor(assetInfo?: any) {
    this.machineHours = assetInfo?.machineHours
    if (containsAllValues(assetInfo?.odometerReading)) {
      this.odometerReading = new DecimalValueAndUnit(assetInfo?.odometerReading)
    } else {
      this.odometerReading = null
    }
  }
}

export default JobAssociatedAssetInfo
